import { CountryMeasurements } from './types';

export const DEFAULT_COUNTRY_MEASUREMENTS: CountryMeasurements = {
  unitOfLength: 'cm',
  unitOfWeight: 'kg',
  currency: '$',
};
